// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2yNLZ","title":"Header_title__2MXdi","left":"Header_left__1ZIYT","clinicName":"Header_clinicName__3Rmu0"};